var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c(
          "b-loading",
          {
            attrs: { "is-full-page": true, "can-cancel": true },
            model: {
              value: _vm.isLoading,
              callback: function ($$v) {
                _vm.isLoading = $$v
              },
              expression: "isLoading",
            },
          },
          [
            _c("b-icon", {
              attrs: {
                pack: "fas",
                icon: "sync-alt",
                size: "is-large",
                "custom-class": "fa-spin",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        this.$route.query.fromOR
          ? _c("h1", { staticClass: "subtitle is-4" }, [
              _vm._v("Oficial de Registro"),
            ])
          : _c("h1", { staticClass: "subtitle is-4" }, [
              _vm._v("Mis certificados"),
            ]),
        _vm._v(" "),
        _c("h1", { staticClass: "title is-3" }, [
          _vm._v("Revocar certificado"),
        ]),
        _vm._v(" "),
        this.$route.query.fromOR
          ? _c("div", { staticClass: "content" }, [
              _c("p", [
                _vm._v(
                  "\n        Puede revocar el certificado del usuario seleccionando la razón correspondiente y\n        agregar un comentario adicional si lo considera necesario.\n      "
                ),
              ]),
            ])
          : _c("div", { staticClass: "content" }, [
              _c("p", [
                _vm._v(
                  "\n        Puede revocar su certificado seleccionando la razón correspondiente y\n        agregar un comentario adicional si lo considera necesario.\n      "
                ),
              ]),
            ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box" },
      [
        _c(
          "b-field",
          { attrs: { label: "Razón de la revocación" } },
          [
            _c(
              "b-dropdown",
              {
                attrs: {
                  disabled: !_vm.existCertToRevoke,
                  "aria-role": "list",
                },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function () {
                      return [
                        _c(
                          "b-button",
                          { attrs: { "icon-right": "caret-down" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.reasonSelected
                                    ? _vm.reasonSelected.mensaje
                                    : "Seleccionar"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.reasonSelected,
                  callback: function ($$v) {
                    _vm.reasonSelected = $$v
                  },
                  expression: "reasonSelected",
                },
              },
              [
                _vm._v(" "),
                _vm._l(_vm.reasons, function (label, i) {
                  return _c(
                    "b-dropdown-item",
                    {
                      key: `label-${i}`,
                      attrs: { value: label, "aria-role": "listitem" },
                    },
                    [_c("span", [_vm._v(_vm._s(label.mensaje))])]
                  )
                }),
              ],
              2
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-field",
          {
            staticClass: "mt-5",
            attrs: { label: "Comentario adicional (opcional)" },
          },
          [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.comment,
                  expression: "comment",
                },
              ],
              staticClass: "textarea",
              attrs: {
                placeholder: "Ingresar comentario adicional",
                disabled: !_vm.existCertToRevoke,
              },
              domProps: { value: _vm.comment },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.comment = $event.target.value
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        this.$route.query.fromOR
          ? _c(
              "b-notification",
              {
                attrs: {
                  type: "is-warning is-light mt-5",
                  "has-icon": "",
                  closable: false,
                },
              },
              [
                _c("i", { staticClass: "fas fa-info mr-4" }),
                _vm._v(
                  "\n      Al revocar el certificado del usuario, este quedará inutilizable.\n    "
                ),
              ]
            )
          : _c(
              "b-notification",
              {
                attrs: {
                  type: "is-warning is-light mt-5",
                  "has-icon": "",
                  closable: false,
                },
              },
              [
                _c("i", { staticClass: "fas fa-info mr-4" }),
                _vm._v(
                  "\n      Al revocar su certificado, este quedará inutilizable.\n      Deberá iniciar una nueva solicitud para obtener un nuevo certificado.\n    "
                ),
              ]
            ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons is-right mt-6" },
          [
            _c(
              "b-button",
              {
                staticClass: "is-primary",
                attrs: { disabled: !_vm.reasonSelected },
                on: { click: _vm.openConfirmDialog },
              },
              [_vm._v("\n        Continuar\n      ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }